import { render } from "./NewWasteCar.vue?vue&type=template&id=52a95e98&scoped=true"
import script from "./NewWasteCar.vue?vue&type=script&lang=js"
export * from "./NewWasteCar.vue?vue&type=script&lang=js"

import "./NewWasteCar.vue?vue&type=style&index=0&id=52a95e98&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a95e98"]])

export default __exports__